import { FeedbackRating } from '@/utils/feedback';
import { create } from 'zustand';

export interface FeedbackStore {
  rating: FeedbackRating | null;
  isModalOpen: boolean;
  isSubmitting: boolean;
  email: string;
  comment: string;
  commentErrors: string[];

  setRating: (rating: FeedbackRating | null) => void;
  setIsModalOpen: (isOpen: boolean) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  setEmail: (email: string) => void;
  setComment: (comment: string) => void;
  setCommentErrors: (errors: string[]) => void;

  resetFeedback: () => void;
}

export const useFeedbackStore = create<FeedbackStore>((set) => ({
  rating: null,
  isModalOpen: false,
  isSubmitting: false,
  email: '',
  comment: '',
  commentErrors: [],

  setRating: (rating) => set({ rating }),
  setIsModalOpen: (isOpen) => set({ isModalOpen: isOpen }),
  setIsSubmitting: (isSubmitting) => set({ isSubmitting }),
  setEmail: (email) => set({ email, commentErrors: [] }),
  setComment: (comment) => set({ comment, commentErrors: [] }),
  setCommentErrors: (errors) => set({ commentErrors: errors }),

  resetFeedback: () =>
    set({
      rating: null,
      isSubmitting: false,
      isModalOpen: false,
      email: '',
      comment: '',
      commentErrors: [],
    }),
}));
